// Assessment overview section form field enum
export enum AssessmentOverviewFormField {
  // Appointment time
  APPOINTMENT_TIME = 'assessment-overview/appointment-time'
}
